import { Auth } from "aws-amplify";
import { NavigateFunction } from "react-router-dom";

/**
 * 未ログイン時にサインイン画面に遷移させる
 * @param navigateFn 遷移関数
 * @returns CognitoUser
 */
export const getUserOrSignIn = async (navigateFn: NavigateFunction) => {
  let user: any;
  try {
    user = await Auth.currentAuthenticatedUser();
  } catch {
    navigateFn("/sign-in");
  }

  return user;
};

/**
 * ログイン時にTOP画面に遷移させる
 * @param navigateFn 遷移関数
 */
export const getUserAndToHome = async (navigateFn: NavigateFunction) => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    if (user) navigateFn("/");
  } catch {}
};

// GW事業者ユーザ判定
export const isGWUser = () => {
  return false;
};
